export enum RequestStatus {
  ALL = 'all',
  OPEN = 'open',
  IN_PROGRESS = 'inprogress',
  FINALIZED = 'finalized',
  CANCELLED = 'cancelled'
}
